import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { urlChanged } from '../../mixins/urls'

class ExoBanner extends Component {
  static NB_URL = `util-${Math.floor(Math.random() * 3) + 1}.simply-hentai.com`;

  constructor(props) {
    super(props)

    this.state = {
      renderable: false,
      timeStamp: Math.round(new Date().getTime() + Math.random() * 10000)
    }
  }

  componentDidMount() {
    this.initAds()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.device !== this.props.device ||
      urlChanged(this.props, prevProps)
    ) {
      this.initAds()
    }
  }

  initAds() {
    setTimeout(() => {
      this.setState(
        {
          renderable: true,
          timeStamp: Math.round(new Date().getTime() + Math.random() * 10000),
          nbHash: Math.round(new Date().getTime() + Math.random() * 10000)
        },
        () => {
          this.addNeverblock()
          this.addLoaderScript()
        }
      )
    }, 1)
  }

  addLoaderScript() {
    const script = document.createElement('script')

    const scriptId = 'exo-' + Math.floor(Math.random(1000000))
    script.id = scriptId
    script.text = "(AdProvider = window.AdProvider || []).push({'serve': {}});"

    document.body.appendChild(script)

    document.getElementById(scriptId).remove()
  }

  getLoader() {
    const myEl = { l: null };
    const event = new CustomEvent("gel", { detail: myEl });
    window.document.dispatchEvent(event);
    return myEl.l;
  }

  addNeverblock() {
    const { nbHash, timeStamp } = this.state

    const neverblockId = this.props.neverblock;
    if (!neverblockId) {
      return;
    }

    const width = this.props.width;
    const height = this.props.height;

    const elem = document.getElementById(`i${timeStamp}`)
    if (elem) {
      const data = {
        type: 'banner',
        width,
        height,
        idzone: neverblockId,
        sub: '1',
        codeId: `i${timeStamp}`
      }
      const loader = this.getLoader()
      if (!loader) {
        return
      }

      Array.from(
        document.querySelectorAll(`script[src*='${ExoBanner.NB_URL}/${nbHash}']`)
      ).forEach(el => {
        el.remove()
      })

      const nbElem = document.getElementById(data.codeId)
      if (!nbElem) {
        return
      }

      nbElem.innerHTML = ''

      const div = document.createElement('div')
      nbElem.appendChild(div)
      data.container = div

      if (loader) {
        loader.addZone(data)
      }

      loader.serve({
        script_url: `https://${
          ExoBanner.NB_URL
        }/${nbHash}/${new Date().getTime()}`,
        force: true
      })
    }
  }

  render() {
    const { renderable, timeStamp, zoneId, neverblock } = this.state

    if (!renderable) {
      return ''
    }

    return (
      <>
        <ins
          className="adsbyexoclick"
          data-zoneid={this.props.zoneId}
          data-keywords=""
        />
        <div id={`i${timeStamp}`} data-id={zoneId} data-nbid={neverblock} />
      </>
    )
  }
}

export default withRouter(ExoBanner)
